type AutoRefreshSubscriber = (enabled: boolean) => void;

let autoRefreshEnabled = true;
const subscribers = new Set<AutoRefreshSubscriber>();

export const getAutoRefreshEnabled = (): boolean => autoRefreshEnabled;

export const publishAutoRefresh = (enabled: boolean): void => {
  autoRefreshEnabled = enabled;
  subscribers.forEach(callback => {
    try {
      callback(enabled);
    } catch (error) {
      console.error('[autoRefreshPubSub] subscriber error', error);
    }
  });
};

export const subscribeAutoRefresh = (
  callback: AutoRefreshSubscriber,
  emitCurrent = true
): (() => void) => {
  subscribers.add(callback);

  if (emitCurrent) {
    callback(autoRefreshEnabled);
  }

  return () => {
    subscribers.delete(callback);
  };
};
